import { HealthStatusEarnRewardsPage } from "./healthStatusEarnRewards";

export const HealthStatusEarnRewards = HealthStatusEarnRewardsPage;
